import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as orderActions from '../Actions/orderActions';
import * as userActions from '../Actions/userActions';
import OrderForm from "../Components/Orders/OrderForm";
import { orderService } from "../Services/OrderService.js";
import { withRouter } from 'react-router';
import { userSchema, orderSchema } from '../Schemas/OrderSchema.js';
import { userService } from "../Services/UserService.js";
import { normalize } from 'normalizr';
import {searchFilterService} from "../Services/SearchFilterService.js";
import {denormalizerService} from "../Services/denormalizerService.js";


class OrderFormContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			tmxMatch: null
		}
		this.saveOrderForm = this.saveOrderForm.bind(this);
		this.fetchTranslators = this.fetchTranslators.bind(this);
		this.reinterpretar = this.reinterpretar.bind(this);
		this.preprocesar = this.preprocesar.bind(this);
		this.reTraduir = this.reTraduir.bind(this);
		this.rate = this.rate.bind(this);
//		this.getTmxMatch=this.getTmxMatch(this);
	}
	
	componentDidMount() {
//		console.log("componentDidMount OrderFormContainer");
		orderService.getTmxMatch(this.props.orderRecord.id)
//					.then(response => {return this.props.actions.fetchTmxMatch(this.props.orderRecord.id, response.data);})
					.then(response => {return this.setState({tmxMatch: response.data});})
					.then(() => {return userService.listUsers();})
					.then(response => {return this.fetchTranslators(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	fetchTranslators(responseData) {
//		console.log("fetchTranslators responseData:");
		var normalizedData = normalize(responseData, [userSchema]);
		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		return 1;
	}
	
	saveOrderForm(order, tmx_match){
//		console.log("handle Submit [saveOrderForm]"+JSON.stringify(order));
		let denormlaizedOrder = denormalizerService.orderDenormalizer(order);
		orderService.updateOrderForm(denormlaizedOrder)
			.then(() => {	/*console.log("Redirect()");*/
							return this.props.history.push('/orderList');})
			.then(response1 => {orderService.updateTmxMatch(order.id, tmx_match[0]);})
			.then(response2 => {orderService.updateTmxMatch(order.id, tmx_match[1]);})
			.catch(err => {/*console.log(err);*/});
//			.then(response1 => { 	console.log("response1.data: "+JSON.stringify(response1.data))});
	}
	
	reinterpretar(orderId, excelTxt){
		const configuration={
			text_extraction: 1,
			word_count: 1,
			tmx_match: 1,
			machine_translation: 0,
			excel_txt: excelTxt,
		}
		orderService.WF_preprocesar(orderId, configuration)
			.then(() => {return this.props.history.push('/orderList');});
	}
	
	preprocesar(orderId){
		const configuration={
			text_extraction: 0,
			word_count: 1,
			tmx_match: 1,
			machine_translation: 0
		}
		orderService.WF_preprocesar(orderId, configuration)
			.then(() => {return this.props.history.push('/orderList');});
	}
	
	reTraduir(orderId){
		orderService.WF_retranslate(orderId)
			.then(() => {return this.props.history.push('/orderList');});
	}
	
	rate(orderId){
		orderService.setRatingFromOrder(orderId)
			.then(() => {return this.props.history.push('/orderList');});
	}
	
//	// Aqui o en el Container
//	getTmxMatch(){
//		console.log("getTmxMatch [1]");
//		orderService.getTmxMatch(this.props.orderRecord.id)
//		.then(() => {	console.log("getTmxMatch [2]");
//					})
//		.catch(err => {console.log(err);});
//	}
	
	render() {
//		console.log("[OrderFormContainer.render()]");
	    return (<OrderForm	order={this.props.orderRecord}
							translators={this.props.translators}
							customerUser={this.props.customerUser}
							tmxMatch={this.state.tmxMatch}
							saveOrderForm={this.saveOrderForm}
							reinterpretar={this.reinterpretar}
							preprocesar={this.preprocesar}
							reTraduir={this.reTraduir}
							rate={this.rate}
							accessToken={this.props.user.access_token}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {orderRecord: state.orders[ownProps.match.params.id],
			user: state.user,
			translators: searchFilterService.objectFilter(state.users, user => {return (user.role=='TRANSLATOR');}),
			//customerUser: state.users[state.orders[ownProps.match.params.id].phase.find(e => e.type==='SOURCE').user]}
			customerUser: state.users[state.orders[ownProps.match.params.id].user]}
	//return {orderRecord: state.orders[ownProps.match.params.id], user: state.user, translators: state.users}
}

function mapDispatchToProps(dispatch) {
	return {actions: bindActionCreators(Object.assign({}, orderActions, userActions), dispatch)}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderFormContainer));